import React from 'react';
import TeamMemberCard from './TeamMemberCard.jsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
SwiperCore.use([Autoplay, Pagination]);

const AboutUs = () => {
  const fran = {
    name: 'Francisca Rojas',
    role: 'Diseño de Miradas, Lifting de Pestañas, Micropigmentación,  Manicurista y Pedicurista',
    photo: '/images/Fran_2.jpg',
  };
  const dani = {
    name: 'Marcelo Bustamante',
    role: 'Barbero',
    photo: 'https://disjteanovqtsuirirkt.supabase.co/storage/v1/object/public/assets/images/equipo/marcelo2.jpg',
  };
  const luz = {
    name: 'Paloma Herrera',
    role: 'Manicurista y Lifting',
    photo: 'https://disjteanovqtsuirirkt.supabase.co/storage/v1/object/public/assets/images/equipo/paloma.jpg',
  };
  const mati = {
    name: 'Daniela Rojas',
    role: 'Makeup Artist',
    photo: 'https://qjtknxnrccistdzzaofk.supabase.co/storage/v1/object/public/assets/images/equipo/dani.png',
  };

   const claudia = {
    name: 'Claudia Bustos',
    role: 'Peluquería y Colorimetría',
    photo: '/images/Claudia.jpg',
  };


    // Array de profesionales (puedes añadir el nuevo aquí)
    const professionals = [fran, mati, dani, luz, claudia];
  return (
    <section id="quienes-somos" className="w-full bg-primary-light py-16">
      {/* Ampliamos el ancho máximo en pantallas muy grandes para que los nombres no se corten */}
      <div className="max-w-7xl 2xl:max-w-[1600px] mx-auto px-4 sm:px-6 md:px-8">
        {/* Título y párrafo fuera del grid */}
        <h2 className="font-serif text-4xl sm:text-5xl text-center pb-4">Nuestros Talentos</h2>
        <p className="text-gray-800 text-center mb-8 text-sm sm:text-base">Conoce al equipo que hace posible la magia...</p>

        {/* Grid del Equipo: layout responsivo y fluido */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 gap-6 sm:gap-6 md:gap-8">
          {professionals.map((p) => (
            <TeamMemberCard key={p.name} name={p.name} role={p.role} photo={p.photo} />
          ))}
        </div>

        {/* Bloque de Cita separado */}
        <div className="mt-12 max-w-3xl mx-auto bg-primary-dark text-white rounded-lg p-6 md:p-8 shadow-md">
          <p className="font-serif text-xl md:text-2xl leading-snug text-center">
            "La belleza es la expresión de tu mundo interior."
          </p>
          <div className="mt-6 flex justify-center">
            <img
              src="/images/fran_firma.png"
              alt="Firma de Fran"
              className="w-40 md:w-48 h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;